import $ from "jquery";
import "./../styles/main.scss";
require('./woocommerce/Global');
require('./helpers/CookieConsent');
import AOS from "aos";
import Glide from "@glidejs/glide";
import Siema from "siema";
$(document).ready(function () {
    AOS.init({
        disable: 'mobile'
    });
    setTimeout(function () { AOS.refresh(); }, 500);
    if ($('.page-template-tpl-references').length) {
        $('.elements').on("mouseover", "a", function (e) {
            e.preventDefault();
            var id = $(e.currentTarget).attr("data-picture");
            $("#" + id).addClass("active");
        });
        $('.elements').on("mouseout", "a", function (e) {
            e.preventDefault();
            var id = $(e.currentTarget).attr("data-picture");
            $("#" + id).removeClass("active");
        });
    }
    if ($('.page-template-tpl-services').length) {
        var navigation_1 = $('#services .menu ul');
        var siema_1 = new Siema({
            selector: '.siema',
            duration: 200,
            easing: 'ease-out',
            perPage: 1,
            startIndex: 0,
            draggable: false,
            multipleDrag: true,
            threshold: 20,
            loop: false,
            rtl: false,
            onInit: function () { },
            onChange: function () {
                navigation_1.find(".current").removeClass("current");
                navigation_1.find("li:eq(" + siema_1.currentSlide + ")").addClass("current");
            }
        });
        navigation_1.on("click", "a", function (e) {
            e.preventDefault();
            siema_1.goTo($(e.currentTarget).parent().index());
        });
    }
    if ($('.page-template-tpl-jobs').length) {
        var navigation_2 = $('#jobs .menu');
        var siema_2 = new Siema({
            selector: '.siema',
            duration: 200,
            easing: 'ease-out',
            perPage: 1,
            startIndex: 0,
            draggable: false,
            multipleDrag: true,
            threshold: 20,
            loop: false,
            rtl: false,
            onInit: function () { },
            onChange: function () {
                navigation_2.find(".current").removeClass("current");
                navigation_2.find("li:eq(" + siema_2.currentSlide + ")").addClass("current");
            }
        });
        navigation_2.on("click", "a", function (e) {
            e.preventDefault();
            siema_2.goTo($(e.currentTarget).parent().index());
        });
    }
    $("body").on("click", "a[href^='#goto-']", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href").replace("goto-", "");
        var posY = $(node).offset().top - $("#main-header").height();
        if (posY >= 0) {
            $.scrollTo(posY, 400);
        }
    });
    $("body").on("click", ".menu-switcher", function (e) {
        e.preventDefault();
        $(e.currentTarget).toggleClass("open");
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
    if ($('.carouselWrapper').length) {
        $('.carouselWrapper').each(function (k, e) {
            var gap = $(e).attr("data-gap") !== void 0 ? $(e).attr("data-gap") : 50;
            var mobileGap = $(e).attr("data-mobile-gap") !== void 0 ? $(e).attr("data-mobile-gap") : 20;
            var view = $(e).attr("data-view") !== void 0 ? $(e).attr("data-view") : 2.5;
            var mobileView = $(e).attr("data-mobile-view") !== void 0 ? $(e).attr("data-mobile-view") : 1.3;
            var type = $(e).attr("data-type") !== void 0 ? $(e).attr("data-type") : "slider";
            var focus = $(e).attr("data-focus") !== void 0 ? $(e).attr("data-focus") : 0;
            var bound = $(e).attr("data-bound") !== void 0 ? $(e).attr("data-bound") : false;
            var lgGap = $(e).attr("data-lg-gap") !== void 0 ? $(e).attr("data-lg-gap") : gap;
            var lgView = $(e).attr("data-lg-view") !== void 0 ? $(e).attr("data-lg-view") : view;
            var mdGap = $(e).attr("data-md-gap") !== void 0 ? $(e).attr("data-md-gap") : lgGap;
            var mdView = $(e).attr("data-md-view") !== void 0 ? $(e).attr("data-md-view") : lgView;
            var smGap = $(e).attr("data-sm-gap") !== void 0 ? $(e).attr("data-sm-gap") : mdGap;
            var smView = $(e).attr("data-sm-view") !== void 0 ? $(e).attr("data-sm-view") : mdView;
            var glide = new Glide(e, {
                type: type,
                focusAt: focus,
                perView: view,
                gap: gap,
                startAt: 0,
                bound: true,
                breakpoints: {
                    1220: {
                        gap: lgGap,
                        perView: lgView
                    },
                    1050: {
                        gap: mdGap,
                        perView: mdView
                    },
                    768: {
                        gap: smGap,
                        perView: smView
                    },
                    568: {
                        focusAt: "center",
                        gap: mobileGap,
                        perView: mobileView
                    }
                }
            });
            glide.mount();
        });
    }
});
